/* SteveDiffUtils.js */

"use strict";
const _ = require("lodash");
const DotDiffFormater = require("./DotDiffFormater");
const jsonpatch = require("fast-json-patch");
const jsonDiffPatch = require("jsondiffpatch").create({
    // used to match objects when diffing arrays, by default only === operator is used
    objectHash: function (obj) {
        // this function is used only to when objects are not equal by ref
        return obj._id || obj.id;
    },
    arrays: {
        // default true, detect items moved inside the array (otherwise they will be registered as remove+add)
        detectMove: true,
        // default false, the value of items moved is not included in deltas
        includeValueOnMove: true,
    },
    textDiff: {
        // default 60, minimum string length (left and right sides) to use text diff algorythm: google-diff-match-patch
        minLength: 1000,
    },
});
class SteveDiffUtils {
    static jsonPatchDiff(before, after) {
        return jsonpatch.compare(before, after);
    }
    static jsonPatchApply(obj, patch) {
        return jsonpatch.applyPatch(obj, patch);
    }
    static dotDiff(before, after, opts) {
        if (_.isPlainObject(before) && _.isPlainObject(after)) {
            let diff = jsonDiffPatch.diff(before, after);
            let formatedDiff = DotDiffFormater.format(diff, before);
            let delta = {};
            formatedDiff.forEach((patch) => {
                let filePath = patch.path;
                if (filePath.startsWith("/")) {
                    filePath = filePath.slice(1);
                }
                let dotPath = filePath.replace(/\//g, ".");
                //add in [] for numbers
                dotPath = dotPath.replace(/\.(\d+)\.*?/g, "[$1]");

                let pathParts, oldIdx;
                switch (patch.op) {
                    case "add":
                        if (_.get(opts, "flattenResults", false)) {
                            delta[dotPath] = {
                                type: "added",
                                value: patch.value,
                            };
                        } else {
                            if (!delta.added) {
                                delta.added = {};
                            }
                            delta.added[dotPath] = patch.value;
                        }
                        break;
                    case "remove":
                        if (_.get(opts, "flattenResults", false)) {
                            delta[dotPath] = {
                                type: "removed",
                                oldValue: _.get(before, dotPath),
                            };
                        } else {
                            if (!delta.removed) {
                                delta.removed = {};
                            }
                            delta.removed[dotPath] = {
                                oldValue: _.get(before, dotPath),
                            };
                        }
                        break;
                    case "replace":
                        if (_.get(opts, "flattenResults", false)) {
                            delta[dotPath] = {
                                type: "updated",
                                oldValue: _.get(before, dotPath),
                                newValue: _.get(after, dotPath),
                            };
                        } else {
                            if (!delta.updated) {
                                delta.updated = {};
                            }
                            delta.updated[dotPath] = {
                                oldValue: _.get(before, dotPath),
                                newValue: _.get(after, dotPath),
                            };
                        }
                        break;
                    case "unchanged":
                        //Not gonna include it here...
                        break;
                    case "moved":
                    case "movedestination":
                        pathParts = patch.path.split("/");
                        oldIdx = Number.parseInt(pathParts[pathParts.length - 1]);

                        if (!delta.moved) {
                            delta.moved = {};
                        }
                        if (_.get(opts, "flattenResults", false)) {
                            delta[dotPath] = {
                                type: "moved",
                                value: _.get(before, dotPath),
                                oldIndex: oldIdx,
                                newIndex: patch.value,
                            };
                        } else {
                            delta.moved[dotPath] = {
                                value: _.get(before, dotPath),
                                oldIndex: oldIdx,
                                newIndex: patch.value,
                            };
                        }
                        break;
                }
            });
            return delta;
        } else {
            throw new Error("dotDiff only works with objects.");
        }
    }
}
module.exports = SteveDiffUtils;
